import React, { useState } from 'react'
import { Alert } from '@adc/ui-core'

function useOnce<T>(set: () => T) {
  const [value] = useState(set)
  return value
}

type ValueChangedAlertProps = {
  text: string
  value: number
}
const ValueChangedAlert = ({ text, value }: ValueChangedAlertProps) => {
  const initialValue = useOnce(() => value)

  return (
    <>
      {value !== initialValue && (
        <Alert
          header='Offer Amount Changed'
          role='caution'
          showIcon
          content={text}
        />
      )}
    </>
  )
}

export default ValueChangedAlert
